import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Logo from "./Logo";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const closeMenu = () => setIsOpen(false);
  const toggleMenu = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [isOpen]);

  const navLinks = [
    { to: "/", label: "Home", icon: "bi-house-door-fill" },
    { to: "/services", label: "Services", icon: "bi-grid-3x3-gap-fill" },
    { to: "/portfolio", label: "Portfolio", icon: "bi-images" },
    { to: "/why-choose-us", label: "Why Choose Us?", icon: "bi-patch-check-fill" },
    { to: "/contact", label: "Contact Us", icon: "bi-envelope-fill" },
  ];

  return (
    <>
      <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
        <NavLink to="/" className="navbar-logo" onClick={closeMenu}>
          <Logo size={40} className="logo-hover-spin" />
          <h1>CadLap</h1>
        </NavLink>

        <ul className="navbar-links">
          {navLinks.map((link) => (
            <li key={link.to}>
              <NavLink
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
              >
                {link.label}
              </NavLink>
            </li>
          ))}
          <li>
            <NavLink to="/quote" className="nav-cta">
              <i className="bi bi-calculator-fill"></i> Get a Quote
            </NavLink>
          </li>
        </ul>

        <button
          type="button"
          className={`navbar-hamburger ${isOpen ? "open" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={isOpen}
        >
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </button>
      </nav>

      <div
        className={`sidebar-backdrop ${isOpen ? "show" : ""}`}
        onClick={closeMenu}
        aria-hidden="true"
      />

      <aside className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <Logo size={32} />
          <span>CadLap</span>
        </div>
        <ul>
          {navLinks.map((link) => (
            <li key={link.to}>
              <NavLink
                to={link.to}
                end={link.to === "/"}
                onClick={closeMenu}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <i className={`bi ${link.icon}`} aria-hidden="true"></i>
                <span>{link.label}</span>
              </NavLink>
            </li>
          ))}
          <li>
            <NavLink
              to="/quote"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <i className="bi bi-calculator-fill" aria-hidden="true"></i>
              <span>Get a Quote</span>
            </NavLink>
          </li>
        </ul>
        <div className="sidebar-footer">
          <a href="mailto:info@cadlap.com" className="sidebar-cta">
            <i className="bi bi-envelope-paper-fill"></i> Email Us
          </a>
        </div>
      </aside>
    </>
  );
};

export default Navbar;